var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { insertSubString } from './StringUtilities';
import { padStart } from 'lodash';
export function timeUnFormatter(value) {
    if (!!value && value.length >= 3) {
        // Time value is 3 or more characters, there must be a :
        if (value.includes(':')) {
            // There is!
            return value;
        }
        else {
            // There isn't, add it in please
            return insertSubString(value, 2, ':');
        }
    }
    return value;
}
export function dateFormatter(value) {
    if (!value)
        return '';
    var datePattern = /^(\d{1,2})?\/?(\d{1,2})?\/?(\d{1,4})?$/;
    var patternMatch = value.match(datePattern);
    var response = value;
    if (patternMatch) {
        response = [patternMatch[1], patternMatch[2], patternMatch[3]].filter(function (it) { return !!it; }).join('/');
    }
    if (value.endsWith('/'))
        response += '/';
    return response;
}
export function monthFormatter(value) {
    if (!value)
        return '';
    var datePattern = /^(\d{1,2})?\/?(\d{1,4})?$/;
    var joiner = '/';
    var patternMatch = value.match(datePattern);
    var response = value;
    if (patternMatch) {
        patternMatch.splice(0, 1);
        response = __spreadArray([], __read(patternMatch), false).filter(function (it) { return !!it; }).join(joiner);
        if (value.endsWith(joiner))
            response += joiner;
        return response;
    }
    return value;
}
export function phoneFormatter(value) {
    if (!value)
        return '';
    var digitsOnly = value.replace(/\D/g, '');
    // 13 numbers
    var matches13Numbers = digitsOnly.match(/^(13)(\d{2})(\d{2})$/);
    if (matches13Numbers && matches13Numbers.length) {
        return [matches13Numbers[1], matches13Numbers[2], matches13Numbers[3]].join(' ');
    }
    // Mobile
    var matchesMobiles = digitsOnly.match(/^(04\d{2})(\d{3})(\d{3})$/);
    if (matchesMobiles && matchesMobiles.length) {
        return [matchesMobiles[1], matchesMobiles[2], matchesMobiles[3]].join(' ');
    }
    // 1300 numbers
    var matches1300Mobiles = digitsOnly.match(/^(1300)(\d{2})(\d{2})(\d{2})$/);
    if (matches1300Mobiles && matches1300Mobiles.length) {
        return [matches1300Mobiles[1], matches1300Mobiles[2], matches1300Mobiles[3], matches1300Mobiles[4]]
            .filter(function (it) { return !!it; })
            .join(' ');
    }
    // 1800 numbers
    var matches1800Mobiles = digitsOnly.match(/^(1800)(\d{2})(\d{2})(\d{2})$/);
    if (matches1800Mobiles && matches1800Mobiles.length) {
        return [matches1800Mobiles[1], matches1800Mobiles[2], matches1800Mobiles[3], matches1800Mobiles[4]].join(' ');
    }
    // landline numbers with region
    var matchesLandLinesWithRegion = digitsOnly.match(/^(0?[1-9])(\d{4})(\d{4})$/);
    if (matchesLandLinesWithRegion && matchesLandLinesWithRegion.length) {
        return [
            padStart(matchesLandLinesWithRegion[1], 2, '0'),
            matchesLandLinesWithRegion[2],
            matchesLandLinesWithRegion[3]
        ].join(' ');
    }
    // landline numbers
    var matchesLandLines = digitsOnly.match(/^(\d{4})(\d{4})$/);
    if (matchesLandLines) {
        return [matchesLandLines[1], matchesLandLines[2]].join(' ');
    }
    return digitsOnly;
}
